interface ProductTableHeaderProps {
  showAction?: boolean;
}

const ProductTableHeader = ({
  showAction = false,
}: ProductTableHeaderProps) => {
  return (
    <div
      className="
        hidden
        items-center

        gap-4

        border-b
        border-stroke

        bg-gray-1

        px-4
        py-3

        text-xs
        font-semibold
        uppercase
        tracking-wide

        text-body

        dark:border-strokedark
        dark:bg-meta-4
        dark:text-bodydark

        lg:flex
      "
    >
      <div className="w-[56px] shrink-0">
        Imagen
      </div>

      <div className="flex-1">
        Producto
      </div>

      <div className="w-[90px] shrink-0 text-right">
        Precio
      </div>

      <div className="w-[90px] shrink-0 text-center">
        Stock
      </div>

      {showAction && (
        <div className="w-[140px] shrink-0 text-center">
          Acción
        </div>
      )}
    </div>
  );
};

export default ProductTableHeader;